import {
    CardProvider,
    CardProviderOptionsState,
    FetchState
} from "@/shared/types";
import * as CardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: CardProviderOptionsState = {
    fetchState: FetchState.Uninitialized,
    cardProvider: CardProvider.None
};

export const useCardProviderOptionsStore = defineStore("cardProviderOptions", {
    state: (): CardProviderOptionsState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setCardProviderOptions (cardProvider: CardProvider) {
            this.cardProvider = cardProvider;
            this.fetchState = FetchState.Loaded;
        },
        getCardProviderOptions (): Promise<any> {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }

            this.setFetchState(FetchState.Loading);
            return CardService.getCardProviderOptions()
                .then(response => {
                    this.setCardProviderOptions(response.data.cardProvider);
                }).catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true});
                });
        }
    }
});